import { PLACEHOLDER_IMAGE_USER } from '@presentation/constants';
import type { FC } from 'react';
import { Avatar } from '../Avatar';
import { ConnectionTag } from './components/ConnectionTag';
import * as Styled from './styled';
import type { ContactInfoProps } from './types';

export * from './types';

export const ContactInfo: FC<ContactInfoProps> = (props) => {
  const { profileImage, buttons = [], values = [], lastConnectedType } = props;

  return (
    <Styled.Wrapper>
      <Styled.AvatarWrapper>
        <Avatar src={profileImage ?? PLACEHOLDER_IMAGE_USER} size={78} />
      </Styled.AvatarWrapper>
      {!!lastConnectedType && <ConnectionTag type={lastConnectedType} />}

      <Styled.DetailList
        items={values.map((value) => ({
          label: value.label,
          value: value.value ?? '-',
        }))}
      />

      {!!buttons.length && (
        <Styled.ButtonContainer>
          {buttons.map((button, index) => (
            <Styled.ButtonWrapper key={index}>{button}</Styled.ButtonWrapper>
          ))}
        </Styled.ButtonContainer>
      )}
    </Styled.Wrapper>
  );
};
